import { comAxiosWithToken } from "../../utils/communucationApi";
import fetchAx from "@/axios.js";
export default {
  namespaced: true,
  state: {
    logs: [],
    myCompanyUsers: [],
  },
  mutations: {
    setLogs(state, payload) {
      payload = payload.map((log) => {
        return {
          ...log,
          fullName: log.user ? log.user.fullName : null,
        };
      });
      state.logs = payload;
    },
    setMyCompanyUsers(state, payload) {
      state.myCompanyUsers = payload;
    },
    addLogs(state, payload) {
      state.logs.push(payload);
    },
  },
  getters: {
    getLogs(state) {
      return state.logs.slice().sort((a, b) => {
        return new Date(b.even1Date) - new Date(a.even1Date); // Tarihe göre sıralama
      });
    },
    getMyCompanyUsers: (state) => state.myCompanyUsers,
  },
  actions: {
    async getAllLog({ commit }) {
      await comAxiosWithToken()
        .get(`/api/Logger/GetLogsByFilter`)
        .then((response) => {
          commit("setLogs", response.data);
        })
        .catch((error) => {});
    },
    async getFilteredLog({ commit }, payload) {
      let { firstDate, secondDate, traceID, userID } = payload;

      // Ana URL'yi birleştiriyoruz
      let url = "/api/Logger/GetLogsByFilter";

      // Parametreleri ekliyoruz
      const params = new URLSearchParams();
      if (firstDate && firstDate == secondDate) {
        const date = new Date(secondDate);
        date.setHours(23, 59, 59, 999);
        const pad = (num) => num.toString().padStart(2, "0");
        const formattedDate = `${date.getFullYear()}-${pad(
          date.getMonth() + 1
        )}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(
          date.getMinutes()
        )}:${pad(date.getSeconds())}.9999+03:00`;
        secondDate = formattedDate;
      }
      if (firstDate) params.append("StartDate", firstDate);
      if (secondDate) params.append("EndDate", secondDate);
      if (traceID) params.append("TraceId", traceID);
      if (userID) params.append("UserId", userID);

      // URL'yi parametrelerle birleştiriyoruz
      const fullUrl = `${url}?${params.toString()}`;

      await comAxiosWithToken()
        .get(fullUrl)
        .then((response) => {
          commit("setLogs", response.data);
        })
        .catch((error) => {
          console.error("Hata:", error);
        });
    },

    async getCompanyUsers({ commit, rootState }) {
      try {
        let url = "/Management/MyAllUsers";
        if (rootState.signalRStore.myUser.email === "becoca_25@hotmail.com") {
          url += "?email=becoca_25@hotmail.com";
        }
        const response = await fetchAx.get(url);
        commit("setMyCompanyUsers", response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },
  },
};
